export default __webpack_public_path__ + "images/77c83312205cd200f233b13fc5ae6cc8-tankBullet4.png";